import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { Card, CardContent } from "@core/components/ui/card";
import { Button } from "@core/components/ui/button";
import { useAuth } from "@core/contexts/AuthContext";
import AccountPageTemplate from "@core/pages/account/AccountPageTemplate";
import { SettingsAppearance } from "../components/SettingsAppearance";

export default function AccountAppearance() {
  const { t } = useTranslation(["common", "settings"]);
  const { profile, loading: authLoading } = useAuth();
  const isPaidPlan = !!profile?.plan_type && profile.plan_type !== "free";

  return (
    <AccountPageTemplate
      title={t("common:account.nav.appearance")}
      description={t("common:account.preferences.description")}
      testId="account-appearance-page"
    >
      {authLoading ? (
        <Card className="border-border bg-card">
          <CardContent className="py-12 text-center text-sm text-muted-foreground">
            {t("settings:loading")}
          </CardContent>
        </Card>
      ) : isPaidPlan ? (
        <Card className="border-border bg-card">
          <CardContent className="pt-6">
            <SettingsAppearance />
          </CardContent>
        </Card>
      ) : (
        <Card className="border-border bg-card">
          <CardContent className="flex flex-col items-center gap-4 py-12 text-center">
            <Lock className="h-8 w-8 text-muted-foreground" />
            <p className="text-muted-foreground">
              {t("settings:upgradeRequired")}
            </p>
            <Button asChild>
              <Link to="/pricing">{t("common:account.nav.subscription")}</Link>
            </Button>
          </CardContent>
        </Card>
      )}
    </AccountPageTemplate>
  );
}
